var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"banner",style:({ 'background-image': _vm.background_image })},[_c('div',{staticClass:"banner-text"},[_vm._v(_vm._s(_vm.bannerText)+" "),_c('p',{staticClass:"nameText"},[_vm._v(_vm._s(_vm.Quote)),_c('v-icon',{staticClass:"material-icons-round"},[_vm._v("check_circle")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }